import { type ReactElement } from 'react';
import cx from 'clsx';
import styles from './avatar.module.css';
import { type AvatarIconSize } from './config';

export interface AvatarIconOverlayProps {
  children: ReactElement;
  iconAltValue?: string;
  iconSize?: AvatarIconSize;
  iconTestId?: string;
}

const DEFAULT_ICON_SIZE: AvatarIconSize = '16';

const ICON_CLASS = {
  '16': styles.avatarIcon16,
  '20': styles.avatarIcon20,
  '24': styles.avatarIcon24,
} satisfies Record<AvatarIconSize, string | undefined>;

export function AvatarIconOverlay({
  children,
  iconAltValue,
  iconSize = DEFAULT_ICON_SIZE,
  iconTestId = '',
}: AvatarIconOverlayProps): ReactElement {
  return (
    <div
      aria-hidden={iconAltValue ? 'false' : 'true'}
      className={cx(styles.avatarIcon, ICON_CLASS[iconSize])}
      data-testid={iconTestId}
      title={iconAltValue}
    >
      {children}
    </div>
  );
}
